package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.DeviceOutline: ImageVector
    get() {
        if (_deviceOutline != null) {
            return _deviceOutline!!
        }
        _deviceOutline = Builder(name = "DeviceOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 16.0f, viewportHeight = 16.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(0.0f, 13.9999f)
                lineTo(0.0f, 12.75f)
                lineTo(7.9327f, 12.75f)
                lineTo(7.9327f, 13.9999f)
                lineTo(0.0f, 13.9999f)
                close()
                moveTo(2.3397f, 11.7564f)
                curveTo(1.9188f, 11.7564f, 1.5625f, 11.6105f, 1.2708f, 11.3189f)
                curveTo(0.9792f, 11.0272f, 0.8333f, 10.6709f, 0.8333f, 10.25f)
                lineTo(0.8333f, 3.0064f)
                curveTo(0.8333f, 2.5855f, 0.9792f, 2.2292f, 1.2708f, 1.9375f)
                curveTo(1.5625f, 1.6458f, 1.9188f, 1.5f, 2.3397f, 1.5f)
                lineTo(13.4935f, 1.5f)
                curveTo(13.8664f, 1.5f, 14.1893f, 1.6205f, 14.4623f, 1.8614f)
                curveTo(14.7352f, 2.1023f, 14.8931f, 2.3985f, 14.9358f, 2.75f)
                lineTo(2.3397f, 2.75f)
                curveTo(2.2756f, 2.75f, 2.2169f, 2.7767f, 2.1634f, 2.8301f)
                curveTo(2.11f, 2.8835f, 2.0833f, 2.9423f, 2.0833f, 3.0064f)
                lineTo(2.0833f, 10.25f)
                curveTo(2.0833f, 10.3141f, 2.11f, 10.3728f, 2.1634f, 10.4263f)
                curveTo(2.2169f, 10.4797f, 2.2756f, 10.5064f, 2.3397f, 10.5064f)
                lineTo(7.9327f, 10.5064f)
                lineTo(7.9327f, 11.7564f)
                lineTo(2.3397f, 11.7564f)
                close()
                moveTo(14.6634f, 12.6137f)
                lineTo(14.6634f, 6.1234f)
                curveTo(14.6634f, 6.086f, 14.6501f, 6.0539f, 14.6234f, 6.0272f)
                curveTo(14.5967f, 6.0005f, 14.5646f, 5.9871f, 14.5272f, 5.9871f)
                lineTo(11.3061f, 5.9871f)
                curveTo(11.2687f, 5.9871f, 11.2366f, 6.0005f, 11.2099f, 6.0272f)
                curveTo(11.1832f, 6.0539f, 11.1698f, 6.086f, 11.1698f, 6.1234f)
                lineTo(11.1698f, 12.6137f)
                curveTo(11.1698f, 12.6511f, 11.1832f, 12.6832f, 11.2099f, 12.7099f)
                curveTo(11.2366f, 12.7366f, 11.2687f, 12.75f, 11.3061f, 12.75f)
                lineTo(14.5272f, 12.75f)
                curveTo(14.5646f, 12.75f, 14.5967f, 12.7366f, 14.6234f, 12.7099f)
                curveTo(14.6501f, 12.6832f, 14.6634f, 12.6511f, 14.6634f, 12.6137f)
                close()
                moveTo(11.0497f, 13.9999f)
                curveTo(10.7358f, 13.9999f, 10.4691f, 13.8901f, 10.2494f, 13.6704f)
                curveTo(10.0297f, 13.4507f, 9.9199f, 13.184f, 9.9199f, 12.8701f)
                lineTo(9.9199f, 5.867f)
                curveTo(9.9199f, 5.5531f, 10.0297f, 5.2864f, 10.2494f, 5.0667f)
                curveTo(10.4691f, 4.847f, 10.7358f, 4.7372f, 11.0497f, 4.7372f)
                lineTo(14.7836f, 4.7372f)
                curveTo(15.0974f, 4.7372f, 15.3642f, 4.847f, 15.5839f, 5.0667f)
                curveTo(15.8036f, 5.2864f, 15.9134f, 5.5531f, 15.9134f, 5.867f)
                lineTo(15.9134f, 12.8701f)
                curveTo(15.9134f, 13.184f, 15.8036f, 13.4507f, 15.5839f, 13.6704f)
                curveTo(15.3642f, 13.8901f, 15.0974f, 13.9999f, 14.7836f, 13.9999f)
                lineTo(11.0497f, 13.9999f)
                close()
                moveTo(12.9151f, 8.1666f)
                curveTo(13.086f, 8.1666f, 13.2278f, 8.1075f, 13.3405f, 7.9892f)
                curveTo(13.4532f, 7.8709f, 13.5096f, 7.7329f, 13.5096f, 7.5752f)
                curveTo(13.5096f, 7.4043f, 13.4533f, 7.2625f, 13.3406f, 7.1498f)
                curveTo(13.228f, 7.0371f, 13.0855f, 6.9807f, 12.9132f, 6.9807f)
                curveTo(12.7542f, 6.9807f, 12.6162f, 7.0371f, 12.4992f, 7.1497f)
                curveTo(12.3822f, 7.2624f, 12.3237f, 7.4048f, 12.3237f, 7.5771f)
                curveTo(12.3237f, 7.7362f, 12.3828f, 7.8742f, 12.5011f, 7.9912f)
                curveTo(12.6194f, 8.1081f, 12.7574f, 8.1666f, 12.9151f, 8.1666f)
                close()
            }
        }
        .build()
        return _deviceOutline!!
    }

private var _deviceOutline: ImageVector? = null
